import App from './modules/App/App'
import Contents from './modules/Contents/Contents'
import Introduction from './modules/Introduction/Introduction'
import ImageReferences from './modules/ImageReferences/ImageReferences';
import Chapters from './modules/Chapters/Chapters';
import Dimensions from './modules/Dimensions/Dimensions';
import Glossary from './modules/Glossary/Glossary';
import Resources from './modules/Resources/Resources';
import Search from './modules/Search/Search';
import Favourites from './modules/Favourites/Favourites';
import Login from './modules/Login/Login';
import ForgotPassword from './modules/ForgotPassword/ForgotPassword';

export const routes = [
    { 
        path: '/',
        component: Contents,
        exact: true,
        title: 'Contents',
        protected: true
    },
    { 
        path: '/introduction',
        component: Introduction,
        exact: true,
        protected: true
    },
    { 
        path: '/image-references',
        component: ImageReferences,
        exact: true,
        protected: true
    },
    { 
        path: '/chapter/:section/:slug',
        component: Chapters,
        exact: true,
        protected: true
    },
    { 
        path: '/product-dimensions',
        component: Dimensions,
        exact: true,
        protected: true
    },
    { 
        path: '/glossary',
        component: Glossary,
        exact: true,
        protected: true
    },
    { 
        path: '/resources',
        component: Resources,
        exact: true,
        protected: true
    },
    { 
        path: '/favourites',
        component: Favourites,
        exact: true,
        protected: true
    },
    { 
        path: '/search',
        component: Search,
        exact: true,
        protected: true
    },
    { 
        path: '/login',
        component: Login,
        exact: true,
    },
    { 
        path: '/forgot-password',
        component: ForgotPassword,
        exact: true,
    },
]


// WEBPACK FOOTER //
// ./client/routes.js